export const AppAccess = {
  ApiAccess: 'ApiAccess',
  MultiCompany: 'MultiCompany',
  DisallowOldQuoting: 'DisallowOldQuoting',
  SalesStores: 'SalesStores',
};
